/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CommunicationStatus,
    CommunicationStatusFromJSON,
    CommunicationStatusFromJSONTyped,
    CommunicationStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface PutClientCommunicationStatus
 */
export interface PutClientCommunicationStatus {
    /**
     * 
     * @type {CommunicationStatus}
     * @memberof PutClientCommunicationStatus
     */
    status?: CommunicationStatus;
}

export function PutClientCommunicationStatusFromJSON(json: any): PutClientCommunicationStatus {
    return PutClientCommunicationStatusFromJSONTyped(json, false);
}

export function PutClientCommunicationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutClientCommunicationStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : CommunicationStatusFromJSON(json['status']),
    };
}

export function PutClientCommunicationStatusToJSON(value?: PutClientCommunicationStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': CommunicationStatusToJSON(value.status),
    };
}


